import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { AvatarModule } from '@y42/core/avatar';
import { IconModule } from '@y42/core/icon';
import { y42ShortLogoIcon } from '@y42/icons';
import { map, Observable } from 'rxjs';
import { UserHttpModel, UserUIModel } from '../../models/user.model';
import { UserQuery } from '../../state';
import { isSystemUser } from '../is-system-user.util';

@UntilDestroy()
@Component({
  selector: 'y42-user-avatar',
  templateUrl: './user-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, AvatarModule, MatTooltipModule, IconModule],
})
export class UserAvatarComponent {
  constructor(private readonly userQuery: UserQuery) {}

  @Input()
  @InputObservable()
  user: UserUIModel | null | undefined = this.userQuery.getActiveUser();
  private readonly user$!: Observable<UserUIModel | null | undefined>;

  @Input() size: number | string = 20;
  @Input() borderColor = 'transparent';

  @Input()
  @InputObservable()
  userIdentity: UserUIModel['id'] | string | null | undefined;
  private readonly userIdentity$!: Observable<UserUIModel['id'] | string | null | undefined>;

  readonly y42ShortLogoIcon = y42ShortLogoIcon;
  readonly isUserProfileSetupComplete = this.userQuery.isUserProfileSetupComplete();

  readonly state = connectState(this, {
    isSystemUser: this.userIdentity$.pipe(
      map((idOrEmail) => idOrEmail && isSystemUser({ email: idOrEmail } as UserHttpModel)),
    ),
  });
}
